import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Accordion, Button, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import "./index.css";
import logo from "../../../assets/images/logo.png";
import venmologo from "../../../assets/images/venmologo.png";
import paypallogo from "../../../assets/images/paypallogo.png";
import squarelogo from "../../../assets/images/squarelogo.png";
import zelle from "../../../assets/images/zelle.png";
import venmo from "../../../assets/images/venmo.svg";
import paypal from "../../../assets/images/paypal.svg";
import editpen from "../../../assets/images/editpen.svg";
import ArrowRightIcon from "../../../assets/images/arrowright.svg";

import moment from "moment";
import Template from "../Template";
import { toast } from "react-toastify";
import axios from "axios";
import { DEV_API, WIN_POINT_RULES, WIN_POINT_RULES_1V1 } from "../../../const";
import { SPORT_ADD, USER_UPDATE } from "../../../store/actionTypes";
import CustomModal from "../../../components/Modal/modal";
import { getRandomNumber } from "../../../func";
import { getPlayerNames } from "../..";

const Payment = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { user } = useSelector((state) => state.auth);
    const {
        playList,
        eventDate,
        point,
        payout,
        eventId,
        sportCategory,
        team1Idx,
        primaryColor,
        secondaryColor,
        editPrimaryTeam,
    } = useSelector((state) => state.sport);
    const startPos = getRandomNumber();
    const { name1, name2, name3, name4 } = getPlayerNames(
        startPos,
        user.name,
        payout
    );

    // Set the default active key to "0"
    const [activeKey, setActiveKey] = useState("0");
    const [modalIsOpen, setModalIsOpen] = useState(false);

    const [payment, setPayment] = useState({
        venmo: "",
        paypal: "",
        cashApp: "",
        zelle: "",
    });

    useEffect(() => {
        if (user && user.payment) {
            setPayment(user.payment);
        }
    }, []);

    const handleAccordionChange = (eventKey) => {
        // Toggle the accordion open/close based on the eventKey
        setActiveKey(eventKey === activeKey ? null : eventKey);
    };

    const handlePlayGame = () => {
        setModalIsOpen(false);
        createGame();
        navigate("/play");
    };

    const confirmGame = async () => {
        const { venmo, paypal, cashApp, zelle } = payment;
        let updateData = {
            search: { _id: user._id },
            modify: {
                payment,
            },
        };

        const response = await axios.put(`${DEV_API}/api/users`, updateData);

        if (response.data.success) {
            dispatch({
                type: USER_UPDATE,
                payload: { user: response.data.result },
            });
            if (venmo || paypal || cashApp || zelle) {
                // navigate("/play");
                setModalIsOpen(true);
            } else {
                toast("A payout source is required to play for real money.");
            }
        } else {
            toast(response.data.message);
        }
    };

    const handleChange = (evt, property) => {
        let updateData = { ...payment };
        updateData[property] = evt.target.value;
        setPayment(updateData);
    };

    const createGame = async () => {
        const userRes = await axios.put(`${DEV_API}/api/users`, {
            search: { _id: user._id },
            modify: {
                balance: user.balance - point,
            },
        });

        if (userRes.data.success) {
            dispatch({
                type: USER_UPDATE,
                payload: { user: userRes.data.result },
            });
        }

        const response = await axios.post(`${DEV_API}/api/games`, {
            player: user._id,
            event: eventId,
            teams: playList.boxscore.teams,
            sportCategory,
            startPos,
            payout,
            player1Name: name1,
            player2Name: name2,
            player3Name: name3,
            player4Name: name4,
            entryPoint: point,
            winPoint:
                payout == 1
                    ? WIN_POINT_RULES[point]
                    : WIN_POINT_RULES_1V1[point],
            selectedTeam: team1Idx,
        });

        if (response.data.success) {
            dispatch({
                type: SPORT_ADD,
                payload: {
                    sportCategory,
                    eventId,
                    team1Idx,
                    startPos,
                    primaryColor,
                    secondaryColor,
                    editPrimaryTeam,
                    payout,
                    point: point,
                    player1Name: name1,
                    player2Name: name2,
                    player3Name: name3,
                    player4Name: name4,
                    isFree: false,
                    ...response.data.result,
                },
            });
            navigate("/play", {
                state: {
                    sportCategory,
                    eventId,
                    team1Idx,
                    startPos,
                    primaryColor,
                    secondaryColor,
                    editPrimaryTeam,
                    payout,
                    point: point,
                    player1Name: name1,
                    player2Name: name2,
                    player3Name: name3,
                    player4Name: name4,
                    isFree: false,
                    ...response.data.result,
                },
            });
        } else {
            toast(response.data.message);
        }
    };

    return (
        <>
            <Template>
                <div className="screen-5-section">
                    <div className="screen-5-content">
                        <div className="screen-top-part">
                            <div className="logo-part">
                                <Link to="/">
                                    <img
                                        src={logo}
                                        alt="logo"
                                        className="img-fluid"
                                    />
                                </Link>
                            </div>
                            <span className="screen-title">
                                Add a Payout Source
                            </span>
                            <p
                                className="px-5 py-3 mt-3 text-white"
                                style={{ backgroundColor: "#1c1a1a94" }}>
                                Payout sources are used to process entry fees
                                and distribute winnings.
                                <br /> Entry fee payments are not legally
                                binding.
                            </p>
                        </div>
                        <div className="payment-method-block">
                            <div className="payment-method-list">
                                <ul>
                                    <li>
                                        <Link>
                                            <img
                                                src={venmologo}
                                                alt="paymentlogo"
                                                className="img-fluid"
                                            />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link>
                                            <img
                                                src={paypallogo}
                                                alt="paymentlogo"
                                                className="img-fluid"
                                            />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link>
                                            <img
                                                src={squarelogo}
                                                alt="paymentlogo"
                                                className="img-fluid"
                                            />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link>
                                            <img
                                                src={zelle}
                                                alt="paymentlogo"
                                                className="img-fluid"
                                            />
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                            <div className="payment-method-process">
                                <Accordion
                                    activeKey={activeKey}
                                    onSelect={handleAccordionChange}>
                                    <Accordion.Item
                                        eventKey="0"
                                        className={`accordion-item-custom ${
                                            activeKey === "0" ? "expanded" : ""
                                        }`}>
                                        <Accordion.Header>
                                            {" "}
                                            <img
                                                src={venmo}
                                                alt="venmo"
                                                className="img-fluid"
                                            />{" "}
                                            <span>Preferred</span>{" "}
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <Form>
                                                <Form.Group
                                                    controlId="formGroupText"
                                                    className="form-group">
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Add your Venmo Username"
                                                        value={payment.venmo}
                                                        onChange={(evt) => {
                                                            handleChange(
                                                                evt,
                                                                "venmo"
                                                            );
                                                        }}
                                                    />
                                                    <img
                                                        src={editpen}
                                                        alt="edit"
                                                        className="img-fluid"
                                                    />
                                                </Form.Group>
                                            </Form>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item
                                        eventKey="1"
                                        className={`accordion-item-custom ${
                                            activeKey === "1" ? "expanded" : ""
                                        }`}>
                                        <Accordion.Header>
                                            <img
                                                src={paypal}
                                                alt="paypal"
                                                className="img-fluid"
                                            />
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <Form>
                                                <Form.Group
                                                    controlId="formGroupText"
                                                    className="form-group">
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Add your Paypal Username"
                                                        value={payment.paypal}
                                                        onChange={(evt) => {
                                                            handleChange(
                                                                evt,
                                                                "paypal"
                                                            );
                                                        }}
                                                    />
                                                    <img
                                                        src={editpen}
                                                        alt="edit"
                                                        className="img-fluid"
                                                    />
                                                </Form.Group>
                                            </Form>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                                <div className="d-flex justify-content-center py-3">
                                    <Button
                                        variant="danger"
                                        onClick={() => {
                                            navigate(-1);
                                        }}
                                        style={{ marginRight: 20, width: 120 }}>
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="primary"
                                        onClick={confirmGame}
                                        style={{ width: 120 }}>
                                        Submit
                                    </Button>
                                </div>
                                <span className="payout-process-time">
                                    Payouts are processed on Mondays
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <CustomModal
                    modalIsOpen={modalIsOpen}
                    setModalIsOpen={setModalIsOpen}
                    border={3}
                    primaryColor="#343a40"
                    backgroundColor="#fff"
                    onRequestClose={() => setModalIsOpen(false)}>
                    <div className="float-left text-center mt-3">
                        <span
                            className="text-black"
                            style={{
                                fontFamily: "BigBlackBear",
                                fontWeight: 900,
                                fontSize: 28,
                                fontStyle: "italic",
                            }}>
                            Your Game
                        </span>
                        <div
                            className="screen-top-part"
                            style={{
                                borderRadius: 0,
                                padding: 10,
                                borderRadius: 20,
                                background:
                                    "linear-gradient(180deg, #211621 0%, #FFF 100%)",
                            }}>
                            <div className="select-team-group">
                                <div className="select-team">
                                    <div className="team-image">
                                        {playList.boxscore ? (
                                            <img
                                                src={
                                                    playList.boxscore.teams[0]
                                                        .team.logo
                                                }
                                                alt={
                                                    playList.boxscore &&
                                                    playList.boxscore.teams[0]
                                                        .team.shortDisplayName
                                                }
                                                style={{
                                                    width: 43,
                                                    height: 43,
                                                }}
                                            />
                                        ) : (
                                            <div></div>
                                        )}
                                    </div>
                                    <span className="text-black">
                                        {playList.boxscore &&
                                            playList.boxscore.teams[0].team
                                                .shortDisplayName}
                                    </span>
                                </div>
                                <div className="opposite-part">
                                    vs{" "}
                                    <span>
                                        {eventDate &&
                                            moment(eventDate).format(
                                                "M/D h:mm"
                                            )}
                                    </span>
                                </div>
                                <div className="select-team">
                                    <div className="team-image">
                                        {playList.boxscore ? (
                                            <img
                                                src={
                                                    playList.boxscore.teams[1]
                                                        .team.logo
                                                }
                                                alt={
                                                    playList.boxscore &&
                                                    playList.boxscore.teams[1]
                                                        .team.shortDisplayName
                                                }
                                                style={{
                                                    width: 43,
                                                    height: 43,
                                                }}
                                                className="img-fluid"
                                            />
                                        ) : (
                                            <div></div>
                                        )}
                                    </div>
                                    <span className="text-black">
                                        {playList.boxscore &&
                                            playList.boxscore.teams[1].team
                                                .shortDisplayName}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="select-money-block">
                            <span
                                className="text-black"
                                style={{
                                    fontFamily: "BigBlackBear",
                                    fontWeight: 900,
                                    fontSize: 28,
                                    fontStyle: "italic",
                                }}>
                                Your PayOut
                            </span>
                            <div
                                className="fee-block"
                                style={{ borderRadius: 0, padding: 20 }}>
                                <div className="fee-info">
                                    <p>
                                        ${point} <span>Entry Fee</span>
                                    </p>
                                </div>
                                <div style={{ padding: "0 30px" }}>
                                    <img
                                        src={ArrowRightIcon}
                                        alt="arrow"
                                        className="img-fluid"
                                    />
                                </div>
                                <div className="fee-info">
                                    <p>
                                        $
                                        {payout == 1
                                            ? WIN_POINT_RULES[point]
                                            : WIN_POINT_RULES_1V1[point]}{" "}
                                        <span>Payout</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <p className="pt-3">
                            *BallHog entry fees are NOT requested until after
                            the game is completed
                        </p>
                        <div className="mt-3">
                            <Button
                                className="btn btn-primary"
                                onClick={handlePlayGame}
                                // disabled={submitting}
                            >
                                Submit
                            </Button>
                        </div>
                    </div>
                </CustomModal>
            </Template>
        </>
    );
};

export default Payment;
